import { render } from "./_form.vue?vue&type=template&id=533e52fe"
import script from "./_form.vue?vue&type=script&lang=js"
export * from "./_form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/maintenance_histories/_form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "533e52fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('533e52fe', __exports__)) {
    console.log('reload')
    api.reload('533e52fe', __exports__)
  }
  
  module.hot.accept("./_form.vue?vue&type=template&id=533e52fe", () => {
    console.log('re-render')
    api.rerender('533e52fe', render)
  })

}


export default __exports__